import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { PageLayout } from '@/components/pagelay';
import { getHead, getServerSideProps } from '@/utils/useHead';
import styles from './index.module.scss';
import HTMLFlipBook from 'react-pageflip';
import Head from 'next/head';
//@ts-ignore
import { Map, Marker, NavigationControl, InfoWindow } from 'react-bmap'
import useRequest from '@/utils/useRequest';
import { Pagina } from '@/components/pagination';
import { useDate } from '@/utils/useDate';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

interface IProps {

}
export { getServerSideProps }

export default ({ navDetail }: any) => {
  const [list, setList] = useState<any>([])
  const [page, setPage] = useState({
    current: 1,
    total: 10,
    pageSize: 10
  })
  const request = useRequest()
  const router = useRouter()
  const t = useTranslations();

  console.log(router.locale);


  const getList = useCallback(async (page?: number) => {
    const { data: list } = await request.get(`/getHomeMenuDetail`, {
      params: {
        page,
        path: router.asPath
      },
      headers: {
        lang: router.locale
      }
    })
    setList(list?.data?.list?.data)
    setPage({
      total: list?.data?.list?.total,
      current: list?.data?.list?.current_page,
      pageSize: list?.data?.list?.per_page
    })
  }, [router.locale])

  const onPageChange = useCallback((currentPage: number) => {
    getList(currentPage)
    setPage({
      ...page,
      current: currentPage
    })
    // window.scrollTo(0, 0)
  }, [page])

  useEffect(() => {
    getList(1)
  }, [router.locale])

  useEffect(() => {
    setPage({
      ...page,
      total: navDetail?.list.total
    })
    setList(navDetail?.list?.data || [])
  }, [])

  return (
    <PageLayout temp='page_crumb'>
      <div className={styles.container}>
        {getHead(navDetail)}
        <i className={styles.bg1}></i>
        <div>
          <ul>
            {
              list.map((item: any) => (
                <li>
                  <a href={item.out_link ? item.out_link : `${router.locale === 'en' ? '/en' : ''}/media/news_detail/${item.id}`} target='_blank'>
                    <div className={styles.time}>
                      {useDate(item.publish_time).day}
                      <p>{useDate(item.publish_time).year}.{useDate(item.publish_time).month}</p>
                    </div>
                    <div className={styles.imgBox}>
                      <img onError={(e: any) => e.target.src = 'http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg'} src={item.show_image} loading='lazy' alt="" />
                    </div>
                    <div className={styles.info}>
                      <p className={styles.title}>{item.info_title}</p>
                      <p>{item.brief}</p>
                    </div>
                    <div className={styles.btn}>
                      {t('common.check')} <p><i></i></p>
                    </div>
                  </a>
                </li>
              ))
            }
          </ul>
          <Pagina
            total={page.total}
            current={page.current}
            pageSize={page.pageSize}
            onPageChange={onPageChange}
          />
        </div>
        <style jsx global>
          {
            `
              
            `
          }
        </style>
      </div>
    </PageLayout>

  );
};


